export class RateSummary
{

}
